var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMercuryFeaturesCard2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 156,
    viewBox: "0 0 172 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.413 61.8196L47.5998 0.351562L0.58667 138.682L171.413 61.8196ZM24.7911 113.225L55.056 23.2215L135.063 63.3115L128.575 65.0255L29.3302 111.115L24.7911 113.225Z",
    fill: "url(#paint0_linear_944_127)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0563 34.4063L121.986 68.1522L135.063 63.3116L55.0563 23.2217L24.7788 113.226L30.0273 110.793L55.0563 34.4063Z",
    fill: "url(#paint1_linear_944_127)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.885 78.7695L171.401 61.8193L0.58667 138.682L2.05779 155.648L170.885 78.7695Z",
    fill: "url(#paint2_linear_944_127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_127",
    x1: 37.6144,
    y1: 28.6047,
    x2: 174.686,
    y2: 129.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_944_127",
    x1: 46.8267,
    y1: 130.333,
    x2: 4.76505,
    y2: 58.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_944_127",
    x1: 85.9937,
    y1: -38.3076,
    x2: 161.091,
    y2: 120.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercuryFeaturesCard2);
export default __webpack_public_path__ + "static/media/mercury_features_card2.cb812fff1abe21b18a71e5e9fabcf211.svg";
export { ForwardRef as ReactComponent };